import { ACCOUNT_INITIALIZE, ORG_DATA, SET_MENU, MENU_OPEN, SET_REPORT_DATA } from '../store/actions';

export const performLogout = (dispatch, routerHistory) => {
  dispatch({ type: ACCOUNT_INITIALIZE, payload: { isLoggedIn: false, user: null, token: '', role: '', org: null } });
  dispatch({ type: ORG_DATA, payload: { org_data: null } });
  dispatch({ type: SET_REPORT_DATA, payload: { reportData: "", title: "" } });
  dispatch({ type: SET_MENU, opened: false });
  dispatch({ type: MENU_OPEN, id: [] });
  localStorage.clear();
  routerHistory.push('/login');
};
